import React, { useState } from "react";
import { Grid, FormControlLabel, Checkbox, Typography } from "@mui/material";

import { CssHeadTextField } from "./CommonStyles";

const CollectorComponent = ({
  childComponentRef,
  setCheckedChild,
  CollectorNameChild,
}) => {
  const [checked, setChecked] = useState(false);
  const [collectorName, setCollectorName] = useState("");
  const [collectorNameValidation, setCollectorNameValidation] = useState({
    msg: "",
    invalid: false,
  });

  const handleCheckboxChange = (event) => {
    if (event.target.checked) {
      childComponentRef.current.resetDeliveryAddress();
      setCollectorName("");
      CollectorNameChild("");
      setChecked(true);
      setCheckedChild(true);
      setCollectorNameValidation({
        msg: "Please Enter Collector Name",
        invalid: true,
      });
      childComponentRef.current.setDeliveryAddressValidationFalse();
    } else {
      childComponentRef.current.resetDeliveryAddress();
      setChecked(false);
      setCheckedChild(false);
      setCollectorName("");
      CollectorNameChild("");
      setCollectorNameValidation({
        msg: "",
        invalid: false,
      });
    }
  };

  const handleCollectorNameChange = (e) => {
    setCollectorNameValidation({
      msg: "",
      invalid: false,
    });
    setCollectorName(e.target.value);
    CollectorNameChild(e.target.value);
    // SetDefaultDelivery(""); // Assuming SetDefaultDelivery is defined elsewhere
  };

  return (
    <Grid item container xs={12} spacing={2}>
      <Grid item xs={2}>
        <FormControlLabel
          id="collect_order_chk"
          title="collector"
          control={<Checkbox style={{ paddingTop: 0 }} />}
          label={<h1>Collect Order</h1>}
          sx={{
            "& .MuiSvgIcon-root": { fontSize: 15, paddingTop: 0 },
            margin: 0,
          }}
          labelPlacement="start"
          onChange={handleCheckboxChange}
        />
      </Grid>

      <Grid item xs={4}>
        <Grid item container xs={12}>
          <Grid item xs={4}>
            <label htmlFor={"Collector Name"} style={{ fontSize: 12 }}>
              Collector Name :
            </label>
          </Grid>
          <Grid item xs>
            <CssHeadTextField
              id={"Collector Name"}
              type="text"
              fullWidth
              size="small"
              value={collectorName}
              inputProps={{
                style: {
                  color: "black",
                  fontWeight: "normal",
                  fontSize: "12px",
                },
              }}
              disabled={!checked}
              onChange={handleCollectorNameChange}
              variant="standard"
              aria-describedby="component-helper-text"
              focused
            />
          </Grid>
        </Grid>

        {collectorNameValidation.invalid ? (
          <Typography style={{ color: "red" }} variant="subtitle2">
            {collectorNameValidation.msg}
          </Typography>
        ) : null}
      </Grid>
    </Grid>
  );
};

export default CollectorComponent;
